import { AnalyticsEvent, AnalyticsEventTemplate, EventName } from './analytics-event';

export class LinkClickEvent implements AnalyticsEvent {
  event: EventName = 'link_click';

  click_text?: string;
  field_name?: string;

  constructor(template: AnalyticsEventTemplate<LinkClickEvent> = {}) {
    Object.assign(this, template);
  }
}
